export default "__VITE_ASSET__a2a9580f__"